import React from 'react';
import PropTypes from 'prop-types';
import { promoComponentPropTypes } from '../../utilities/commonPropTypes';
import { buildOfferSchema } from '../../utilities/offerSchema';

const PromoOfferSchema = ({ promo }) => {
	const schema = buildOfferSchema(promo);
	if (!schema) return null;

	// Escape `<` so promo text can't break out of the script tag (e.g. a
	// title containing "</script>").
	const json = JSON.stringify(schema).replace(/</g, '\\u003c');

	return (
		<script
			type="application/ld+json"
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{ __html: json }}
		/>
	);
};

PromoOfferSchema.propTypes = {
	promo: PropTypes.shape(promoComponentPropTypes).isRequired
};

export default PromoOfferSchema;
